import clsx from 'clsx'
import React, { forwardRef } from 'react'

type RadioInputProps = React.InputHTMLAttributes<HTMLInputElement>

export const RadioInput = forwardRef<HTMLInputElement, RadioInputProps>(
  (props, forwardedRef) => {
    const selectorClassName = clsx(
      'w-4 h-4',
      'flex items-center justify-center',
      'border border-gray-400 peer-checked:border-thatch-300 peer-disabled:border-gray-400 rounded-full',
      'bg-white peer-checked:bg-thatch-500 peer-disabled:bg-gray-200',
      'text-transparent peer-checked:text-white peer-disabled:text-gray-200 peer-disabled:peer-checked:text-gray-400',
      'outline outline-offset-2 outline-2 outline-transparent peer-focus-visible:outline-thatch-500 group-[]/radio-container:peer-focus-visible:outline-transparent',
      'transition'
    )

    return (
      <div>
        <div className='relative rounded-lg shadow-[0_0_0_0rem] has-[:hover]:shadow-[0_0_0_0.5rem] group-hover/radio-container:shadow-[0_0_0_0.5rem] shadow-transparent has-[:hover]:shadow-gray-800/5 group-hover/radio-container:shadow-gray-800/5 has-[:disabled]:has-[:hover]:shadow-transparent transition'>
          <input
            {...props}
            className='appearance-none absolute left-0 top-0 w-4 h-4 opacity-0 peer cursor-pointer disabled:cursor-default'
            ref={forwardedRef}
            type='radio'
          />
          <div className={selectorClassName}>
            <svg
              aria-hidden
              className='h-3 w-3'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              xmlns='http://www.w3.org/2000/svg'
            >
              <circle cx='6' cy='6' r='2' fill='currentColor' />
            </svg>
          </div>
        </div>
      </div>
    )
  }
)
